import { Grid } from '@material-ui/core';
import ReportProblemOutlinedIcon from '@material-ui/icons/ReportProblemOutlined';
import React from 'react';
import {
  popEmeraldModal,
  pushEmeraldModal,
} from 'src/common/emerald-modal-manager/emerald-modal-manager';
import { endOfDayExecute } from './business-logic/end-of-day-execute';
import { ExecutionTiming } from './business-logic/end-of-day-status';
import { styles } from './end-of-day-styles';
import EmeraldDialog from 'src/common/components/emerald-dialog/emerald-dialog';

export const showEndOfDayDialog = (): void => {
  pushEmeraldModal(<EndOfDay />);
};

const EndOfDay: React.FC = (): JSX.Element | null => {
  const classes = styles();
  const handleEndOfDayExecute = async (executionTiming: ExecutionTiming): Promise<void> => {
    await endOfDayExecute(executionTiming);
    closeEndOfDayDialog();
  };
  const closeEndOfDayDialog = (): void => {
    popEmeraldModal();
  };
  return (
    <EmeraldDialog
      open
      fullWidth={true}
      classes={{
        paper: classes.dialogPaper,
      }}
      data-testid='dialog-end-of-day-execute'
    >
      <Grid container direction='column'>
        <Grid item className={classes.titleItem}>
          <Grid
            container
            justifyContent='space-between'
            className={`${classes.titleContainer} fullWidth`}
          >
            <Grid item wrap={'nowrap'}>
              <span className={classes.contentTitle}>Executing EOD</span>
            </Grid>
            <Grid item>
              <ReportProblemOutlinedIcon classes={{ root: `${classes.icon}` }} />
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <Grid container item justifyContent='center' alignItems='center'>
            <div className={classes.progressBar}>
              <div
                className={`${classes.bar} ${classes.widthAnimation}`}
                data-testid='end-of-day-animation'
                onAnimationStart={() => handleEndOfDayExecute(ExecutionTiming.Immediate)}
                onAnimationEnd={closeEndOfDayDialog}
              />
            </div>
          </Grid>
        </Grid>
        <Grid item>
          <Grid container item justifyContent='center' alignItems='center' wrap={'nowrap'}>
            <span className={classes.contentDescription}>Execution in progress..</span>
          </Grid>
        </Grid>
      </Grid>
    </EmeraldDialog>
  );
};
export default EndOfDay;
